const rankingItems = [
  { rank: 1, title: '斗破苍穹', tags: ['热血', '玄幻'], status: '连载中', heat: '980万' },
  { rank: 2, title: '斗罗大陆', tags: ['热血', '冒险'], status: '连载中', heat: '920万' },
  { rank: 3, title: '一人之下', tags: ['都市', '奇幻'], status: '连载中', heat: '860万' },
  { rank: 4, title: '完美世界', tags: ['玄幻', '热血'], status: '连载中', heat: '810万' },
  { rank: 5, title: '镖人', tags: ['武侠', '历史'], status: '连载中', heat: '750万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">全网漫画热度实时排行，发现大家都在追的好作品</p>
        </div>
        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-5 p-4 md:p-5 bg-background-50 rounded-xl mb-3 last:mb-0 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-heading text-lg flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-secondary-400 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <div className="flex items-center gap-2 flex-wrap">
                  {item.tags.map((tag, j) => (
                    <span key={j} className="text-xs px-2 py-0.5 rounded-full bg-background-200 text-foreground-500 whitespace-nowrap">{tag}</span>
                  ))}
                  <span className="text-xs text-foreground-400">{item.status}</span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-fire-line text-sm"></i>
                  <span className="text-sm font-semibold whitespace-nowrap">{item.heat}</span>
                </div>
                <span className="text-xs text-foreground-400">热度值</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}